import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=1fca6a31"
import script from "./DiscountBanner.vue?vue&type=script&lang=js"
export * from "./DiscountBanner.vue?vue&type=script&lang=js"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=1fca6a31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports